export default "__VITE_ASSET__6dOUkHjP__"